/**
 * Web no-op stubs for push notifications.
 *
 * Metro resolves this file (`.web.ts`) on web, so the web bundle never imports
 * `expo-notifications` (native-only here; web pushes are not part of this
 * system). Keep this in sync with the native `pushNotifications.ts` exports.
 */

export type NotificationTap = {
  link: string | null;
  id: string;
};

export function isPushSupported(): boolean {
  return false;
}

export async function registerForPushNotifications(): Promise<boolean> {
  return false;
}

export async function unregisterPushNotifications(): Promise<void> {}

export function addNotificationTapListener(
  _callback: (tap: NotificationTap) => void,
): () => void {
  return () => {};
}

export async function getInitialNotificationTap(): Promise<NotificationTap | null> {
  return null;
}
